import Icon from '../components/Icon.vue'

Icon.register({
  utensils: {
    width: 416,
    height: 512,
    paths: [
      {
        d: 'M207.9 15.2c0.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6l12.9 238.1c0.7 13.7-10.2 25.3-24 25.3h-64c-13.7 0-24.7-11.5-24-25.3l12.9-238.1c-41.2-15-68.9-52.4-68.9-104.6 0-34.4 15.3-124.1 16.1-128.8 3.2-20.3 45.3-20.6 47.9 1.1v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 0.2 2.7 6.6 116.5 8 141.8 0.9 3.2 14.8 3.4 16 0v-141.2c2.6-21.6 44.8-21.4 48-1.1zM327.1 300.9c-156.5-122.4-17.6-300.9 64.9-300.9 13.3 0 24 10.8 24 24v464c0 13.3-10.7 24-24 24h-56c-14 0-25.1-12-23.9-26z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/utensils.js
// module id = 2083
// module chunks = 0